import type { ParentProps } from "solid-js";
import { useI18n } from "@/api/i18n";
import { Button } from "@/components/ui/button";

type RefineStepCardProps = ParentProps<{
  onEdit: () => void;
  title: string;
}>;

export function RefineStepCard(props: RefineStepCardProps) {
  const { t } = useI18n();

  return (
    <div class="group relative rounded-lg border bg-card p-6">
      <h3 class="text-base font-medium mb-4">{props.title}</h3>
      {props.children}
      <Button
        variant="outline"
        size="sm"
        class="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-[opacity,color,background-color,box-shadow,scale]"
        onClick={props.onEdit}
      >
        {t("jobOffers.refine.edit")}
      </Button>
    </div>
  );
}
